<template>
    <div class="medical-records">
        <div class="row mb-4 Nutrition-questionair">
            <div class="col-12">
                <div class="card border-0">
                    <div class="card-body bg-white border-radius-5">
                        <!-- Tab panes -->
                        <div class="tab-content">
                            <div class="tab-pane active" id="custom" role="tabpanel">
                                <div class="row no-gutters justify-content-center p-5 custom">
                                    <div class="col-md-6 text-center">
                                        <h2 class="mb-4">A custom vitamin just for you, that changes with you</h2>
                                        <p class="mb-4">Get the precise supplementation you need at the right time to get ahead in your health.</p>
                                        <ul class="mb-0 justify-content-center align-items-center d-flex">
                                            <li><router-link to="/custom-suppliment-questionaries" class="btn btn-blue mr-3 discover">Add your Past Suppliments</router-link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane" id="generic" role="tabpanel">
                                <div class="row no-gutters">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div class="Vital-Logs"><a href="#" class="btn btn-vital">Vital Logs</a></div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane" id="recommended" role="tabpanel">
                                <div class="row no-gutters">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div class="Vital-Logs"><a href="#" class="btn btn-vital">Vital Logs</a></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Nutrition",
        data() {
            return {
                

            }
        },
        created(){
           this.pageName('Nutrition and Supplements');
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/website/nutrition/pages/already-taking-suppliment.vue